<mat-checkbox
  [checked]="value()"
  [disabled]="disabled()"
  (change)="checkBoxChange.emit($event.checked)"
>
</mat-checkbox>
